<template>
  <div class="toggle-container">
    <div class="toggle-options">
      <span :class="{ active: !selectedOption && !pendingOption }">{{ option1 }}</span>
      <label class="switch">
        <input type="checkbox" v-model="isRight" @change="handleToggleChange" />
        <span :class="sliderClass"></span>
      </label>
      <span :class="{ active: selectedOption && !pendingOption }">{{ option2 }}</span>
    </div>
    <confirmation-dialog
      v-if="isConfirmationVisible"
      @confirm="confirmChange"
      @cancel="cancelChange"
    />
  </div>
</template>

<script>
import ConfirmationDialog from './OConfirmationDialog.vue';

export default {
  components: {
    ConfirmationDialog,
  },
  props: {
    option1: {
      type: String,
      required: true,
    },
    option2: {
      type: String,
      required: true,
    },
    selectedOption: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isRight: this.selectedOption === 1,
      isConfirmed: false,
      isConfirmationVisible: false,
      pendingOption: null,
      cancel0: false,
      cancel1: false,
      cancelStatus: false
    };
  },
  computed: {
    sliderClass() {
      if (this.pendingOption === true) {
        return ['slider', 'round', { 'pending-right': this.isConfirmationVisible && this.isRight, 'pending-left': this.isConfirmationVisible && !this.isRight }];
      }
      if (this.cancelStatus) {
        return ['slider', 'round', { 'cancel-1': this.cancel1 && !this.cancel0, 'cancel-0': !this.cancel1 && this.cancel0 }];
      }
      return ['slider', 'round', { 'cancel-1': this.selectedOption == 1, 'cancel-0': this.selectedOption == 0 }];
    },
  },
  watch: {
    selectedOption: {
      immediate: true,
      handler(newVal) {
        this.isRight = newVal === 1;
      }
    },
  },
  methods: {
    handleToggleChange() {
      this.pendingOption = true;
      this.isConfirmationVisible = true;
    },
    confirmChange() {
      this.cancelStatus = false;
      this.isConfirmed = true;
      this.emitSelectedData();
      this.isConfirmationVisible = false;
      this.pendingOption = false;
    },
    cancelChange() {
      console.log(this.isRight, this.selectedOption);
      if (this.selectedOption === 0) {
        this.isRight = false;
      } else {
        this.isRight = true;
      }
      
      if (this.selectedOption === 1){
        this.cancel1 = true;
      }else {
        this.cancel0 = true;
      }
      this.cancelStatus = true;
      this.isConfirmed = false;
      this.isConfirmationVisible = false;
      this.pendingOption = false;
    },
    emitSelectedData() {
      const selected = this.isRight ? 1 : 0;
      this.$emit('option-selected', selected);
    },
  },
};
</script>

<style scoped>
.toggle-container {
  display: flex;
  align-items: center;
}

.toggle-options {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 200px;
}

.toggle-options span {
  font-size: 10px;
  font-weight: bold;
  color: #94a3b8;
}

.toggle-options span.active {
  font-weight: bold;
  color: var(--primary-color, #F93E3E);
}

.switch {
  position: relative;
  display: inline-block;
  width: 80px;
  height: 34px;
  margin: 0 10px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e2e8f0;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #e2e8f0;
}

input:checked + .slider:before {
  transform: translateX(23px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.slider.round.pending-right:before {
  transform: translateX(13px);
}

.slider.round.pending-left:before {
  transform: translateX(13px);
}

.slider.round.cancel-1:before {
  transform: translateX(23px);
}

.slider.round.cancel-0:before {
  transform: translateX(2px);
}
</style>
